export default __webpack_public_path__ + "static/media/Umberto Tozzi.d9da116c.jpg";